import { useVizFrameworkConfig } from "./config.js";
function useAnalytics() {
    const config = useVizFrameworkConfig();
    return config?.analyticsClient;
}
export { useAnalytics };

//# sourceMappingURL=analytics.js.map